import { render } from "./SurveyInfo.vue?vue&type=template&id=2ca7dc7b&scoped=true"
import script from "./SurveyInfo.vue?vue&type=script&lang=js"
export * from "./SurveyInfo.vue?vue&type=script&lang=js"

import "./SurveyInfo.vue?vue&type=style&index=0&id=2ca7dc7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca7dc7b"]])

export default __exports__